import axios from 'axios';
import router from '../router';
import store from '../store';

import { defaultLangCode } from '../common/constants/globalConfig';
import { refreshToken, logout } from '../router/accountUnit';
import { errorNotify } from '@/common/mixin/common';
import i18n from '@/common/lang/i18n';

const refreshTokenUrl = '/refresh-token';
const request = axios.create({
  baseURL: window.env.api.baseUrl || process.env.VUE_APP_BASE_API,
  timeout: 15000,
});
// 请求base url
/* axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
axios.defaults.timeout = 10 * 1000; */
// 请求拦截
request.interceptors.request.use(
  config => {
    // 获取过期时间及上次更新时间信息
    let expireTime = store.getters.Getter_ExpireTime;
    // let expireTime = '{"updateTime":1536286254891,"expire":30000}';
    if (expireTime) {
      let lastUpdateTime = store.getters.Getter_LastUpdateTime;
      let activeTime = new Date().getTime() / 1000 - lastUpdateTime;
      // 用户登录还未过期
      if (activeTime < expireTime) {
        // 当token快过期时再去刷新一遍token，保证用户不会掉线
        if (activeTime >= (expireTime / 5) * 4) {
          // 过滤掉刷新token接口，否则会进入死循环
          if (!new RegExp(refreshTokenUrl).test(config.url) && store.getters.Getter_Token) {
            refreshToken(request);
          }
        }
      }
    } else {
      // 如果激活时间大于等于过期时间，并且当前页面需要登录才能访问，则退出登录
      // console.log('6 长时间未活动');
      if (router.app.$route.meta.requireAuth) {
        errorNotify(i18n.t('v.common.session.timeout'));
        logout(() => {
          router.push('/login');
          window.location.reload(true);
        });
      }
    }
    if (store.getters.Getter_Token) {
      let storageToken = localStorage.getItem('token');
      // 用户在其他标签页退出了
      if (!storageToken) {
        logout(() => {
          router.push('/login');
          window.location.reload(true);
        });
        return config;
      }
      // 让每个请求携带token
      config.headers['Authorization'] = store.getters.Getter_Token;
    }

    let lang = store.getters.Getter_Lang;

    config.headers['lang'] = lang.code || defaultLangCode;
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// 请求错误时不需要显示错误信息的URL
let notShowError = {
  login: '/login',
  exchange: '/exchange',
};
// notification最后一次显示的时间，为防止短时间内过多出现
let lastNotificationShowtime;
// 响应拦截
request.interceptors.response.use(
  response => {
    let data = response.data;
    // todo 模拟异常响应
    // if (!new RegExp('/v2/u/gt/register').test(response.config.url)) {
    //   data.errcode = errorCode.OPENED_GOOGLE_CODE;
    // }
    // setRequestState(response.config.url,true)
    if (response.headers && (response.headers['content-type'] === 'application/octet-stream;charset=utf-8')) {
      return response;
    }
    if (typeof data.errcode !== 'undefined' && data.errcode !== 0 && data.errcode !== '0') {
      // 登录接口，如果错误类型是需要谷歌验证码，则不显示错误信息，因为会有输入谷歌验证码的弹窗
      // 60089 不允许商家交易
      //  token超时    || token篡改   ||    token内容缺失  ||    权限不足

      // Session Timeout
      if (data.errcode == 40001) {
        logout(() => {
          errorNotify(i18n.t('v.common.session.timeout'));
          router.push('/login');
          window.location.reload(true);
        });
        return Promise.reject(data);
      }
      if (data.errcode === 'Unauthorised') {
        logout(() => {
          errorNotify(data.errmsg);
          router.push('/login');
          // window.location.reload(true);
        });
        return Promise.reject(data);
      }
      if (data.errcode === 41001 || data.errcode === 41002 || data.errcode === 41003) {
        logout(() => {
          router.push('/login');
          window.location.reload(true);
        });
        return Promise.reject(data);
      }
      if (
        new RegExp(notShowError.login).test(response.config.url) ||
        new RegExp(notShowError.exchange).test(response.config.url)
      ) {
        // google验证码 和 第一次交易时输入交易密码 错误提示不需要弹出
        if (data.errcode === '1904' || data.errcode === 60088) {
          // 走失败回调
          return Promise.reject(data);
        }
      }
      // 重复点击错误码不要弹出
      if (data.errcode === 499) {
        return Promise.reject(data);
      }

      // let errMsg = errorCodeMap[curLang][data.errcode];
      let time = new Date().getTime();
      let notificationDuration = 4500;
      // 防止短时间内出现多个notification
      if (!lastNotificationShowtime || time - notificationDuration >= lastNotificationShowtime) {
        errorNotify(data.errmsg);
        lastNotificationShowtime = time;
      }
      // 41004 用户 当前账户已经被禁用 需要弹出提示
      if (data.errcode === 41004) {
        logout(() => {
          router.push('/login');
        });
      }
      // 走失败回调
      return Promise.reject(data);
    }
    return data;
  },
  error => {
    return Promise.reject(error);
  }
);

export default request;
